import * as firebase from "firebase/app";
import { getApiDomain } from "./domainUtils";
import "whatwg-fetch";

function handleErrorsAndGetJson(response) {
  if (!response.ok) {
    throw Error(response.status + " " + response.statusText);
  }
  const contentType = response.headers.get("content-type");

  if (contentType && contentType.includes("application/json")) {
    return response.json();
  }
  return response.body;
}

const unAuthenticatedRequest = (method, url, body) => {
  var request = {
    method: method,
    headers: {
      "Content-Type": "application/json",
    },
    ...(method === "POST" && { body: JSON.stringify(body) }),
  };

  return window.fetch(url, request).then(handleErrorsAndGetJson);
};

export const getLocationsList = (programType) =>
  unAuthenticatedRequest("GET", `${getApiDomain()}/locations-2/${programType}`);

export const getLocationInfo = (programType, locationId) =>
  unAuthenticatedRequest(
    "GET",
    `${getApiDomain()}/location-info-2/${programType}/${locationId}`
  );
